import { effect, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/core/services/language.service';

export function paginatorIntlFactory(): MatPaginatorIntl {
  const translateService = inject(TranslateService);
  const languageService = inject(LanguageService);
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    const ofLabel = translateService.instant('PAGINATOR__OF_LABEL');

    if (length === 0 || pageSize === 0) {
      return `0 ${ofLabel} ${length}`;
    }

    const total = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < total ? Math.min(startIndex + pageSize, total) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} ${ofLabel} ${total}`;
  };

  effect(() => {
    languageService.language();

    paginatorIntl.itemsPerPageLabel = translateService.instant('PAGINATOR__ITEMS_PER_PAGE');
    paginatorIntl.nextPageLabel = translateService.instant('PAGINATOR__NEXT_PAGE');
    paginatorIntl.previousPageLabel = translateService.instant('PAGINATOR__PREVIOUS_PAGE');
    paginatorIntl.changes.next();
  });

  return paginatorIntl;
}
